import { SET_CURRENT_TAB } from '../actions/tab';

const initialState = 'domains';

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_CURRENT_TAB: {
      return action.currentTab || initialState;
    }
    default:
      return state;
  }
}
